import { useFrame } from "@react-three/fiber";
import React, { useRef } from "react";

export default function GlobeComponent(props) {
  const mesh = useRef();

  useFrame((clock, camera) => {
    mesh.current.rotation.y += 0.0025;
  });

  return (
    <mesh
      ref={mesh}
      castShadow
      scale={props.scale}
      position={props.position}
      onClick={props.onclick}
    >
      <sphereBufferGeometry args={[1, 100, 100]} />
      {/* <meshBasicMaterial attach="material" map={props.texture} opacity="6" roughness={1} metalness={1} /> */}
      <meshStandardMaterial
        attach="material"
        map={props.texture}
        transparent
        roughness={0.8}
        metalness={0.8}
        opacity={1}
      />
    </mesh>
  );
}
